<template>
  <b-modal
    id="regenerate-bill-modal"
    no-close-on-backdrop
    title="Regenerate Trip Bill"
    hide-footer
  >
    <b-tabs>
      <b-tab>
        <template #title>
          <feather-icon
            icon="TruckIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Dropoff</span>
        </template>
        <BillMap @refetch-bill="$emit('refetch-data')" />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon
            icon="CalendarIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Distance/Time</span>
        </template>
        <BillDistanceTime @refetch-bill="$emit('refetch-data')" />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>
<script>
import { BModal, BTabs, BTab } from 'bootstrap-vue'
import BillMap from './BillMap.vue'
import BillDistanceTime from './BillDistanceTime.vue'

export default {
  components: {
    BModal,
    BillMap,
    BillDistanceTime,
    BTabs,
    BTab,
  },

}
</script>
  <style scoped>
  </style>
